var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import config from '@/config';
import SignalRService from '@/shared/services/SignalRService';
import eventBus from 'pubsub-js';
import { getCurrentTime } from '@/shared/components/registration/registrationHelpers';
import api from '../api';
import SharedWorkerPolyfill from './SharedWorkerPolyfill';
import userStorage from './userStorage';
import AuthService, { functionalities, privileges } from './AuthService';
var lastRegStorageKey = 'LastTmrReg';
var TimerRegistrationService = /** @class */ (function () {
    function TimerRegistrationService() {
    }
    // Timer worker methods
    TimerRegistrationService.postMessageToWorker = function (message) {
        if (this.worker) {
            this.worker.postMessage(message);
        }
    };
    TimerRegistrationService.stopTimer = function () {
        this.postMessageToWorker({ event: 'stop' });
    };
    TimerRegistrationService.startTimer = function (registrationId) {
        if (AuthService.hasPermission({
            functionality: functionalities.RegistrationOwn,
            privilege: privileges.Create,
        }))
            this.postMessageToWorker({ event: 'start', registrationId: registrationId });
    };
    TimerRegistrationService.setRegistrationId = function (registrationId) {
        this.postMessageToWorker({ event: 'setRegistrationId', registrationId: registrationId });
    };
    TimerRegistrationService.createTimerRegistration = function (value) {
        var _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var data, result, registrationId;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!AuthService.hasPermission({
                            functionality: functionalities.RegistrationOwn,
                            privilege: privileges.Create,
                        })) {
                            return [2 /*return*/, Promise.reject()];
                        }
                        return [4 /*yield*/, api.base.post("".concat(config.appUrls.api, "/api/TimerRegistration/StartTimer"), value)];
                    case 1:
                        data = (_d.sent()).data;
                        result = data;
                        this.current = result;
                        registrationId = (_c = (_b = this.current) === null || _b === void 0 ? void 0 : _b.registration) === null || _c === void 0 ? void 0 : _c.id;
                        if (result === null || result === void 0 ? void 0 : result.registration) {
                            userStorage.setItem(lastRegStorageKey, value);
                            this.startTimer(registrationId);
                        }
                        eventBus.publish('timerRegistrationChanged');
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TimerRegistrationService.restartTimerRegistration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lastReg;
            return __generator(this, function (_b) {
                if (!AuthService.hasPermission({
                    functionality: functionalities.RegistrationOwn,
                    privilege: privileges.Create,
                })) {
                    return [2 /*return*/, Promise.reject()];
                }
                lastReg = userStorage.getItem(lastRegStorageKey);
                if (!lastReg)
                    return [2 /*return*/, Promise.resolve(null)];
                lastReg.fromMinutes = getCurrentTime();
                return [2 /*return*/, this.createTimerRegistration(lastReg)];
            });
        });
    };
    TimerRegistrationService.stopTimerRegistration = function (pause) {
        var _b;
        if (pause === void 0) { pause = false; }
        return __awaiter(this, void 0, void 0, function () {
            var data, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!AuthService.hasPermission({
                            functionality: functionalities.RegistrationOwn,
                            privilege: privileges.Create,
                        })) {
                            return [2 /*return*/, Promise.reject()];
                        }
                        if (!pause) {
                            userStorage.setItem(lastRegStorageKey, null);
                        }
                        this.stopTimer();
                        if (!((_b = this.current) === null || _b === void 0 ? void 0 : _b.registration))
                            return [2 /*return*/, Promise.resolve(null)];
                        return [4 /*yield*/, api.base.get("".concat(config.appUrls.api, "/api/TimerRegistration/StopTimer/").concat(this.current.registration.id), {
                                params: { now: getCurrentTime() },
                            })];
                    case 1:
                        data = (_c.sent()).data;
                        result = data;
                        this.current = null;
                        eventBus.publish('timerRegistrationChanged');
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TimerRegistrationService.pauseTimerRegistration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.stopTimerRegistration(true)];
            });
        });
    };
    var _a;
    _a = TimerRegistrationService;
    TimerRegistrationService.worker = null;
    TimerRegistrationService.current = null;
    TimerRegistrationService.SharedWorkerSupported = 'SharedWorker' in globalThis;
    TimerRegistrationService.init = function () {
        if (_a.SharedWorkerSupported) {
            _a.worker = new SharedWorkerPolyfill('/assets/scripts/timerSharedWorker.js', {
                name: 'TimerRegistrationWorker',
            });
            _a.worker.onmessage = _a.handleWorkerMessage;
            _a.worker.start();
        }
        SignalRService.subscribe('timerRegistrationUpdated', function (data) {
            var _b, _c;
            _a.current = data;
            var registrationId = (_c = (_b = _a.current) === null || _b === void 0 ? void 0 : _b.registration) === null || _c === void 0 ? void 0 : _c.id;
            _a.setRegistrationId(registrationId);
            eventBus.publish('timerRegistrationChanged');
        });
        if (AuthService.hasPermission({
            functionality: functionalities.RegistrationOwn,
            privilege: privileges.Create,
        })) {
            api.base.get("".concat(config.appUrls.api, "/api/TimerRegistration")).then(function (_b) {
                var _c, _d;
                var data = _b.data;
                _a.current = data;
                var registrationId = (_d = (_c = _a.current) === null || _c === void 0 ? void 0 : _c.registration) === null || _d === void 0 ? void 0 : _d.id;
                _a.setRegistrationId(registrationId);
                eventBus.publish('timerRegistrationChanged');
            });
        }
        window.addEventListener('unload', function () {
            if (_a.worker) {
                _a.worker.postMessage({ event: 'disconnect' });
                _a.worker.close();
            }
        });
    };
    TimerRegistrationService.handleWorkerMessage = function (_b) {
        var data = _b.data;
        var message = data;
        if (!message)
            return;
        switch (message.event) {
            case 'tick': {
                _a.doTimerTick(message.registrationId);
                break;
            }
            default:
                break;
        }
    };
    TimerRegistrationService.doTimerTick = function (registrationId) {
        if (!AuthService.hasPermission({
            functionality: functionalities.RegistrationOwn,
            privilege: privileges.Update,
        })) {
            return;
        }
        api.base
            .get("".concat(config.appUrls.api, "/api/TimerRegistration/UpdateTimer/").concat(registrationId), {
            params: { now: getCurrentTime() },
        })
            .then(function (_b) {
            var _c;
            var data = _b.data;
            _a.current = data;
            if (!((_c = _a.current) === null || _c === void 0 ? void 0 : _c.registration)) {
                _a.stopTimer();
            }
        }, function (error) {
            _a.current = null;
            _a.stopTimer();
            console.error(error);
        });
    };
    TimerRegistrationService.isRunning = function () {
        if (!_a.current)
            return false;
        return _a.current.isRunning;
    };
    TimerRegistrationService.getRunningRegistration = function () {
        if (!_a.current || !_a.current.isRunning)
            return null;
        return _a.current.registration;
    };
    TimerRegistrationService.isPaused = function () {
        if (_a.isRunning())
            return false;
        return !!userStorage.getItem(lastRegStorageKey);
    };
    return TimerRegistrationService;
}());
export default TimerRegistrationService;
